import * as React from "react";

interface Props {
  viewBox?: string;
  color: string;
  size: string;
}

export const ProductRoomIcon = (props: Props) => (
  <svg
    width={props.size}
    height={props.size}
    viewBox={props?.viewBox}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.8333 9.66666V17.1667H17.1666V14.6667H3.83329V17.1667H2.16663V3.83333H3.83329V12.1667H10.5V6.33333H15.5C16.384 6.33333 17.2319 6.68452 17.857 7.30964C18.4821 7.93476 18.8333 8.78261 18.8333 9.66666ZM17.1666 12.1667V9.66666C17.1666 9.22463 16.991 8.80071 16.6785 8.48815C16.3659 8.17559 15.942 7.99999 15.5 7.99999H12.1666V12.1667H17.1666ZM7.16663 9.66666C7.38764 9.66666 7.5996 9.57886 7.75588 9.42258C7.91216 9.2663 7.99996 9.05434 7.99996 8.83333C7.99996 8.61231 7.91216 8.40035 7.75588 8.24407C7.5996 8.08779 7.38764 7.99999 7.16663 7.99999C6.94561 7.99999 6.73365 8.08779 6.57737 8.24407C6.42109 8.40035 6.33329 8.61231 6.33329 8.83333C6.33329 9.05434 6.42109 9.2663 6.57737 9.42258C6.73365 9.57886 6.94561 9.66666 7.16663 9.66666ZM7.16663 11.3333C6.50358 11.3333 5.8677 11.0699 5.39886 10.6011C4.93002 10.1323 4.66663 9.49637 4.66663 8.83333C4.66663 8.17029 4.93002 7.5344 5.39886 7.06556C5.8677 6.59672 6.50358 6.33333 7.16663 6.33333C7.82967 6.33333 8.46555 6.59672 8.93439 7.06556C9.40323 7.5344 9.66663 8.17029 9.66663 8.83333C9.66663 9.49637 9.40323 10.1323 8.93439 10.6011C8.46555 11.0699 7.82967 11.3333 7.16663 11.3333Z"
      fill={props.color}
    />
  </svg>
);
